import { GAME_ID } from '../../data/constants';

const initialState = { alyxState: 0 };

const alyxReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case 'SET_ALYX_STATE':
      return {
        ...state,
        alyxState: payload,
      };

    case 'ROUND_END':
      return initialState;

    default:
      return state;
  }
};

export default alyxReducer;
